import { slugToName } from '@virginexperiencedays/search/utils/category';

export const breadcrumbs = (crumbs: string, slugNameMap?: Record<string, string>) => {
  if (!crumbs) {
    return [];
  }

  const slugs = crumbs.split('/');

  const getSlugName = (slug) => slugNameMap?.[slug] ?? slugToName(slug);
  return slugs.map((slug) => ({ name: getSlugName(slug), path: `/${slug}` }));
};
